<template>
  <div class="adviser-enrolment-wrapper">
    <div class="adviser-enrolment-content">
      <div :class="{ 'mb-12': !flush }">
        <h1>{{ heading }}</h1>
        <p class="lead" :class="`lead-${leadWeight}`" v-html="lead"></p>
        <p
          v-for="(paragraph, index) in paragraphs"
          :key="index"
          :class="{ 'paragraph-body': paragraphSize === 'body' }"
          v-html="paragraph"
        ></p>
        <p v-if="footnote" class="footnote">{{ footnote }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  // "Why Wills matter" intro block. Copy comes in through props; the
  // defaults are the channel-page wording so callers that pass nothing keep
  // today's content.
  export default {
    name: 'AdviserEnrolmentIntro',
    props: {
      heading: {
        type: String,
        default: 'Why Wills Matter',
      },
      // HTML allowed (bold phrases).
      lead: {
        type: String,
        default:
          '<strong>85% of South Africans die without a will,</strong> leaving their <strong>families vulnerable</strong> when the unexpected happens. As trusted financial advisers, <strong>you have the power to change this.</strong>',
      },
      // "medium" = Montserrat 500 22/26 (channel pages); "regular" = 400 22/28 (/adviser).
      leadWeight: {
        type: String,
        default: 'medium',
        validator: value => ['medium', 'regular'].includes(value),
      },
      // HTML allowed.
      paragraphs: {
        type: Array,
        default: () => [
          "Through the <strong>Old Mutual Will platform</strong>, we're making it easier than ever to help clients <strong>protect their legacy and provide for their loved ones.</strong>",
        ],
      },
      footnote: {
        type: String,
        default: '',
      },
      // "lead" = same 22/26 as the lead (/adviser); "body" = 16/24 (channel pages).
      paragraphSize: {
        type: String,
        default: 'lead',
        validator: value => ['lead', 'body'].includes(value),
      },
      // Drops the 48px bottom margin when a divider follows, so the HR's own
      // 88px is the whole gap.
      flush: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-enrolment-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 80px;
  }

  .adviser-enrolment-content {
    @include adviser-content-column;
  }

  h1 {
    @include adviser-heading-a;
    margin-bottom: 24px;
  }

  p {
    @include adviser-font;
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    letter-spacing: -0.055px;
    color: $adviser-text;
    margin: 0 0 40px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .lead-regular {
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0;
  }

  .paragraph-body {
    @include adviser-body;
    letter-spacing: 0;
  }

  .footnote {
    @include adviser-sub-line;
    font-size: 12px;
    line-height: 16px;
  }
</style>
